export function extractErrorMessage(value: unknown): string | undefined {
  if (typeof value === 'string') return value
  if (value && typeof value === 'object') {
    const obj = value as Record<string, unknown>
    const msg = obj.message ?? obj.detail ?? obj.error
    if (typeof msg === 'string') return msg
    if (Array.isArray(msg)) return msg.map(String).filter(Boolean).join('; ')
    if (msg && typeof msg === 'object') return extractErrorMessage(msg)
  }
  return undefined
}

interface EventDataResponse {
  object?: string
  id?: string
}

interface GetSubmitParamsInput {
  currentEvent?: { data?: { id?: string } } | null
  eventReviewData?: {
    data?:
      | { value?: { data?: EventDataResponse }; data?: EventDataResponse }
      | { data?: EventDataResponse }
  } | null
}

export function getReviewSubmitParams(input: GetSubmitParamsInput): {
  model_type: 'event' | 'item'
  model_id: string | undefined
} {
  const { currentEvent, eventReviewData } = input

  if (currentEvent?.data?.id) {
    return {
      model_type: 'event',
      model_id: currentEvent.data.id,
    }
  }

  const eventDataResponse =
    eventReviewData?.data?.value ?? eventReviewData?.data
  const innerData = eventDataResponse?.data ?? eventDataResponse

  const modelType =
    innerData?.object === 'OrderItem' ? ('item' as const) : ('event' as const)

  return {
    model_type: modelType,
    model_id: innerData?.id,
  }
}
